import { SerializedBaseNode } from "@/features/screenplay/components/editor/nodes/BaseNode"
import { SceneNode } from "@/features/screenplay/components/editor/nodes/SceneNode"
import { isZeroWidthOrEmpty } from "@/features/screenplay/components/editor/utils/NodeUtils"
import { SerializedTextNode } from "lexical"

export const getSceneHeader = (element: SerializedBaseNode | SceneNode) => {

    if (element instanceof SceneNode) {
        const text = element?.getTextContent()
        return isZeroWidthOrEmpty(text)
            ? '[No Title]'
            : text.trim()
    }
    const concatText = element.children
        .filter((child: any) => child.type === 'text' || 'text' in child)
        .map((child: any) => (child as SerializedTextNode).text)
        .join('')
    const text = isZeroWidthOrEmpty(concatText)
        ? '[No Title]'
        : concatText.trim()
    return text
}

export const getTextContent = (serializedNode: SerializedBaseNode) => {
    const concatText = serializedNode.children
        .filter((child: any) => child.type === 'text' || 'text' in child)
        .map((child: any) => (child as SerializedTextNode).text)
        .join('')
    return concatText
}